export default {

    animationName: 'fade-up',
    animationDuration: 1500,
    animationDelay: 0,
    animationAnchor: 'top-center'

}


// WEBPACK FOOTER //
// ./src/store/elementSettings/animateonscrollsettings.js